import { handleApi } from "./common";

const DIY_API_CONSTANTS = {
  categories: "/api/funds/category/subcategories/v2",
  trendingFunds: "/api/persona/trends/gettrendingfunds",
  diyfundlist: "/api/funds/",
  search: "api/funds/search?search_key",
};

export const fetch_search_results = async (Api, token, searchTerm) => {
  const url = `${DIY_API_CONSTANTS.search}=${searchTerm}`;
  const res = await Api.get(url, {}, {}, token);
  const data = handleApi(res);
  return data;
};

export const fetch_diy_categories = async (Api, token) => {
  const res = await Api.get(DIY_API_CONSTANTS.categories, {}, {}, token);
  const data = handleApi(res);
  return data;
};

export const fetch_trending_funds = async (Api, token) => {
  const res = await Api.get(DIY_API_CONSTANTS.trendingFunds, {}, {'Cache-Control' : 'no-cache'}, token);
  const data = handleApi(res);
  return data;
};

export const fetch_sub_category_fund_list = async ({
  Api,
  category,
  subcategoryOption,
  token,
}) => {
  const url =
    DIY_API_CONSTANTS.diyfundlist + `${category}/${subcategoryOption}/sip/v2`;
  const res = await Api.get(url, {}, {}, token);
  const data = handleApi(res);
  return data;
};
